module.exports = __webpack_public_path__ + "img/shoot_00037.c00b90ae.png";